import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export interface BreadcrumbItem {
  name: string;
  path?: string; // last item usually has no path
}

/**
 * Visual breadcrumbs only — emit the matching BreadcrumbList JSON-LD via the
 * SEO component's jsonLd prop (generateBreadcrumbStructuredData).
 */
const PageBreadcrumbs: React.FC<{ items: BreadcrumbItem[] }> = ({ items }) => (
  <Breadcrumbs
    separator={<NavigateNextIcon fontSize="small" />}
    aria-label="breadcrumb"
    sx={{ mb: 3 }}
  >
    {items.map((item, i) =>
      item.path && i < items.length - 1 ? (
        <Link
          key={item.name}
          component={RouterLink}
          to={item.path}
          underline="hover"
          color="text.secondary"
          variant="body2"
        >
          {item.name}
        </Link>
      ) : (
        <Typography key={item.name} variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
          {item.name}
        </Typography>
      ),
    )}
  </Breadcrumbs>
);

export default PageBreadcrumbs;
